import { Link } from 'react-router-dom';

import Button from 'honeydew/Button';
import DrawerModal from 'shared/DrawerModal';

/**
 * Warning modal displayed when a user adds more than 5 products to their recurring
 * items list in a single session. This helps users understand that recurring items
 * are charged in addition to their regular cart.
 *
 * @param {Object} props
 * @param {boolean} [props.isOpen=false] - Whether the modal is open
 * @param {Function} props.onClose - Callback when modal is closed
 */
export function RecurringLimitWarningModal({ isOpen = false, onClose }) {
    if (!isOpen) {
        return null;
    }

    return (
        <DrawerModal
            onClose={onClose}
            drawerProps={{
                sx: { zIndex: 6000 },
            }}
            modalProps={{
                centered: true,
                styles: { contentRoot: 'py-40 px-60' },
                includeHorizontalPadding: false,
            }}
        >
            <div className="flex flex-col">
                <h2 className="text-heading-xs mb-15 md:mb-10">Heads up!</h2>
                <p className="mb-15 text-body-mobile-sm md:mb-20 md:text-body-mobile-md">
                    We noticed you&apos;ve added five products to your recurring list.
                    <br />
                    <br />
                    Items on your recurring list will automatically get added to every order, in addition to your
                    pre-filled cart. You can always edit your recurring products in your{' '}
                    <Link to="/account/food-preferences" className="underline">
                        account preferences
                    </Link>
                    .
                </p>
                <Button variant="primary" onClick={onClose}>
                    Got it
                </Button>
            </div>
        </DrawerModal>
    );
}
